// extracted by mini-css-extract-plugin
module.exports = {"barContainer":"ProgressBar_barContainer__2dFjA","progressBar":"ProgressBar_progressBar__f0g6W","failed":"ProgressBar_failed__2a63g"};